export const UPLOAD_STARTED = 'UPLOAD_STARTED';
export const UPLOAD_FAILED = 'UPLOAD_FAILED';
export const UPLOAD_SUCCESS = 'UPLOAD_SUCCESS';
export const UPLOAD_RESET = 'UPLOAD_RESET';
export const SET_UPLOAD_INITIAL_PROGRESS = 'SET_UPLOAD_INITIAL_PROGRESS';
export const SET_UPLOAD_PROGRESS = 'SET_UPLOAD_PROGRESS';
